import {cloneDeep} from 'lodash';
import {Component, Input, OnInit} from '@angular/core';
import {AsyncPipe, CommonModule, NgIf} from '@angular/common';
import {EmailStatusDetailsService} from '@app/components/projects/eMailCampaigns/e-mails-batch-list/email-status-details/email-status-details.service';
import {DxPopupModule, DxProgressBarModule} from 'devextreme-angular';
import {StoreTreeComponent} from '@app/4dm1n/store-tree/store-tree.component';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {GenericListModule} from '../../../../../../@shared/_generalTools/generic-list/generic-list.module';
import {Column} from 'devextreme/ui/data_grid';
import {IGenericListSelection} from '../../../../../../@shared/_generalTools/generic-list/generic-list.component';
import {JsonEditorComponent} from '../../../../../../@shared/_generalTools/json-editor/json-editor.component';
import {TabModule} from '@syncfusion/ej2-angular-navigations';
import {ApplicationPipesModule} from '../../../../../../application-pipes/application-pipes.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {environment} from '@environments/environment';
import {confirm} from 'devextreme/ui/dialog';
import {LoadingDirectiveModule} from "../../../../../../@shared/loading-directive/loading-directive.module";

@Component({
    selector: 'app-email-status-details',
    templateUrl: './email-status-details.component.html',
    imports: [
        MatIconModule,
        DxPopupModule,
        NgIf,
        LoadingDirectiveModule,
        MatButtonModule,
        DxProgressBarModule,
        GenericListModule,
        TabModule,
        JsonEditorComponent,
        ApplicationPipesModule,
        MatCheckboxModule,
        AsyncPipe
    ],
    styleUrls: ['./email-status-details.component.scss']
})
export class EmailStatusDetailsComponent extends OnDestroyMixin implements OnInit {

  @Input() title: string;
  @Input() campaignUuid: string;
  @Input() waveUuid: string;

  modeSelectSelected = new FormControl(false);

  private BASE_URL = environment.apiUrl;

  columns: Column[] = [
    {
      dataField: '_id',
      visible: false,
    },
    {
      dataField: 'lastUpdate',
      caption: 'Update',
      dataType: 'date',
    },
    {
      dataField: 'email.to',
      caption: 'To',

    },
    {
      dataField: 'mailgunLogs.failed.delivery-status.message',
      caption: 'Message',
    }
  ];

  // $.mailgunLogs.failed['delivery-status'].message

  curSelection = null;
  curEmailsSelected: string[] = [];
  curMail = null;

  constructor(
    public emailStatusDetailsService: EmailStatusDetailsService,
  ) {
    super();

    this.progressBarStatusFormat = this.progressBarStatusFormat.bind(this);

    this.emailStatusDetailsService.status$.pipe(
      untilComponentDestroyed(this)
    ).subscribe((data) => {
      if (data.display) {
      }
    });

  }

  ngOnInit(): void {
  }


  closePopup() {
    this.emailStatusDetailsService.hideDetails();
  }

  progressBarStatusFormat(ratio: number) {
    ratio = Math.floor(ratio * 100);
    return `Downloading ${this.emailStatusDetailsService.status$.value.downloadInfo.totalSizeInMo}Mo - ${ratio}%`;
  }


  onSelectionChanged($event: IGenericListSelection) {

    if (this.modeSelectSelected.value === false) {

      // const copy = JSON.parse(JSON.stringify($event.objects[0]));
      // const emailCopy = JSON.parse(JSON.stringify($event.objects[0]));
      const copy = cloneDeep($event.objects[0]);
      const emailCopy = cloneDeep($event.objects[0]);

      this.curMail = emailCopy.email.mailBody;

      delete copy.email.mailBody;
      this.curSelection = copy;

    }

    this.curEmailsSelected = $event.objects.map((o) => {
      return o.email?.to;
    });


  }

  resendBatchSelected() {

    confirm(
      `Are you sure you want to resend this ${this.curEmailsSelected?.length} emails batch?`,
      'Resend Batch',
    ).then((dialogResult) => {

      if (dialogResult) {
        this.emailStatusDetailsService.reSendWaveForSpecificEmails(this.campaignUuid, this.waveUuid, this.curEmailsSelected);
      }

    });

  }


}
